import React from 'react';
import { useLocation } from 'react-router-dom';

import { ROUTES } from 'consts';
import { useQueryValues } from 'hooks/url.hook';
import { useAppSelector } from 'store/store.hook';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';

import { ZonesTab, GetTabValueProps } from './zones-tab';

export const ZonesTabInZones = () => {
  const { building } = useQueryValues(['building']);
  const location = useLocation();
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);

  const buildingId = building ? Number(building) : null;

  const getTabValue = ({ buildingId, status }: GetTabValueProps) => {
    switch (status) {
      case 'active': {
        return buildingId ? `${ROUTES.ZONES_ACTIVE}?building=${buildingId}` : ROUTES.ZONES_ACTIVE;
      }

      case 'inactive': {
        return buildingId ? `${ROUTES.ZONES_INACTIVE}?building=${buildingId}` : ROUTES.ZONES_INACTIVE;
      }

      default: {
        return '';
      }
    }
  };

  const getCurrentTabValue = () => {
    return `${location.pathname}${location.search}`.replace(`/${orgSlug}/zones/`, '');
  };

  return <ZonesTab buildingId={buildingId} getTabValue={getTabValue} getCurrentTabValue={getCurrentTabValue} />;
};
